import { Tag } from '@nimbus-ds/components';
import { ProductsWithoutStockOrganizeEnum } from '@tiendanube/common/src/domains/products/enums';
import {
  InteractiveListPriv,
  InterfaceNameValue,
} from '@tiendanube/components';
import { CardWithTitle } from 'commons/components';
import useTranslationCatalog from 'domains/Catalog/useTranslationCatalog';

export interface ProductsWithoutStockSearchCardProps {
  searchNoStockProductToBottom: ProductsWithoutStockOrganizeEnum;
  readonly onChange: (event: InterfaceNameValue) => void;
}

function ProductsWithoutStockSearchCard({
  searchNoStockProductToBottom,
  onChange,
}: ProductsWithoutStockSearchCardProps) {
  const t = useTranslationCatalog();
  const handleOnChange = ({ name }) => {
    onChange({
      name: 'searchNoStockProductToBottom',
      value: name,
    });
  };

  return (
    <CardWithTitle
      title={t('products.search.productsWithoutStockSearchCard.title')}
      subtitle={t('products.search.productsWithoutStockSearchCard.subtitle')}
      tag={
        <Tag appearance="primary">
          {t('products.search.productsWithoutStockSearchCard.tag')}
        </Tag>
      }
    >
      <InteractiveListPriv>
        <InteractiveListPriv.RadioItem
          value={ProductsWithoutStockOrganizeEnum.STOCK_AT_THE_END}
          checked={
            searchNoStockProductToBottom ===
            ProductsWithoutStockOrganizeEnum.STOCK_AT_THE_END
          }
          onChange={handleOnChange}
          title={t(
            'products.search.productsWithoutStockSearchCard.stockAtTheEnd',
          )}
        />
        <InteractiveListPriv.RadioItem
          value={ProductsWithoutStockOrganizeEnum.DEFAULT_ORDER}
          checked={
            !searchNoStockProductToBottom ||
            searchNoStockProductToBottom ===
              ProductsWithoutStockOrganizeEnum.DEFAULT_ORDER
          }
          onChange={handleOnChange}
          title={t(
            'products.search.productsWithoutStockSearchCard.defaultOrder',
          )}
        />
        <InteractiveListPriv.RadioItem
          value={ProductsWithoutStockOrganizeEnum.STOCK_HIDDEN}
          checked={
            searchNoStockProductToBottom ===
            ProductsWithoutStockOrganizeEnum.STOCK_HIDDEN
          }
          onChange={handleOnChange}
          title={t(
            'products.search.productsWithoutStockSearchCard.stockHidden',
          )}
        />
      </InteractiveListPriv>
    </CardWithTitle>
  );
}

export default ProductsWithoutStockSearchCard;
